<template>
  <div class="be-content">
    <div class="main-content container-fluid">
      <div class="row" v-if="false">
        <div class="col-lg-4">
          <div class="widget">
            <div class="widget-head">
              <div class="tools"><span class="icon mdi mdi-chevron-down"></span><span
                class="icon mdi mdi-refresh-sync"></span></div>
              <span class="title">Оплаты, тыс. руб.</span>
            </div>
            <div class="widget-chart-container">
              <div class="counter">
                <div class="value">16 850 ₽</div>
                <div class="desc">К оплате в текущем периоде</div>
              </div>
              <payments id="line-chart1" class="chart"></payments>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="widget">
            <div class="widget-head">
              <div class="tools"><span class="icon mdi mdi-chevron-down"></span><span
                class="icon mdi mdi-refresh-sync"></span></div>
              <span class="title">Количество гостей</span>
            </div>
            <div class="widget-chart-container">
              <guests-count id="line-chart2" class="chart"></guests-count>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="widget">
            <div class="widget-head">
              <div class="tools"><span class="icon mdi mdi-chevron-down"></span><span
                class="icon mdi mdi-refresh-sync"></span></div>
              <span class="title">Льготные и неплательщики</span>
            </div>
            <div class="widget-chart-container">
              <div class="counter">
                <div class="value">7,2%</div>
                <div class="desc">Гостей со льготами</div>
              </div>
              <privilege-stats id="line-chart3" class="chart"></privilege-stats>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <operator-select/>
      </div>
    </div>
  </div>
</template>

<script>
  import Payments from './Payments'
  import GuestsCount from './GuestsCount'
  import PrivilegeStats from "./PrivilegeStats";
  import OperatorSelect from "../operators/OperatorSelect";

  export default {
    name: "dashboard",
    components: {
      OperatorSelect,
      PrivilegeStats,
      Payments, GuestsCount
    }
  }
</script>

<style scoped>
  .chart {
    height: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue